import React, { useState, useEffect } from 'react';
import axios from 'axios';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import {
  TextField,
  Button,
  Container,
  Grid,
  CircularProgress,
  Typography,
} from '@material-ui/core';

import { useSnackbar } from 'notistack';
import styles from './styles';
import logoTCImg from '../../../../assets/images/logo_tc.png';
import openedEmail from '../../../../assets/images/openedEmail.png';
import schemaAuth from './Validators';

function InformEmail(props) {
  const { classes } = props;

  const { enqueueSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(false);
  const [submit, setSubmit] = useState(false);

  const [email, setEmail] = useState('');
  const [statusEmail, setStatusEmail] = useState('');

  useEffect(() => {
    document.title = 'Extracto Bank | Informe seu E-mail';
  }, []);

  const handleValidationError = (err) => {
    err.inner.forEach((element) => {
      switch (element.path) {
        case 'email':
          setStatusEmail(element.message);
          break;
        default:
          break;
      }
    });
  };

  async function submitEmail(emailUser) {
    await axios
      .post('https://auth.trocacreditos.com.br/v1/redefine-password', {
        username: emailUser,
        frontend: window.ENV.LOCATION,
        location: '/newPassword',
        profile: 'sales_counter',
      })
      .then(() => {
        setSubmit(true);
      })
      .catch((error) => {
        setLoading(false);
        enqueueSnackbar(error.message, {
          variant: 'warning',
        });
      });
  }

  const handleInformEmail = () => {
    setLoading(true);
    schemaAuth
      .validate(
        {
          email,
        },
        { abortEarly: false },
      )
      .then(() => {
        submitEmail(email);
      })
      .catch((err) => {
        handleValidationError(err);
        setLoading(false);
        enqueueSnackbar(
          'Não foi possível realizar o operação. Verifique seu e-mail e tente novamente.',
          {
            variant: 'warning',
          },
        );
      });
  };
  return (
    <Container maxWidth="xs" className="lg-mg-top">
      <Grid container justify="center" spacing={4} style={{ marginTop: -80 }}>
        <Grid item>
          <Grid container justify="center">
            <img src={logoTCImg} alt="logo" className={classes.imgLogo} />
          </Grid>
        </Grid>
        <Grid item>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleInformEmail();
            }}
          >
            {submit ? (
              <Grid item container justify="center" xs={12} spacing={2}>
                <Typography style={{ marginBottom: 15 }}>
                  Por favor, acesse o e-mail: <strong>{email} </strong>para
                  alterar sua senha.
                </Typography>

                <img
                  src={openedEmail}
                  alt="logo"
                  className={classes.imgEmail}
                />
              </Grid>
            ) : (
              <>
                <Grid item container sm={12} xs={12} spacing={2}>
                  <Grid item xs={12}>
                    <Typography style={{ marginBottom: 15 }}>
                      <strong>
                        Para alterar sua senha, informe seu E-mail de acesso.
                      </strong>
                    </Typography>
                    <TextField
                      variant="outlined"
                      fullWidth
                      autoFocus
                      autoComplete="off"
                      type="email"
                      label="Email"
                      value={email}
                      error={!!statusEmail}
                      helperText={statusEmail}
                      onChange={(e) => {
                        if (statusEmail) {
                          setStatusEmail('');
                        }
                        setEmail(e.target.value);
                      }}
                      FormHelperTextProps={{ error: true }}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      color="primary"
                      disabled={loading}
                      size="large"
                      endIcon={loading && <CircularProgress size={24} />}
                    >
                      Enviar
                    </Button>
                  </Grid>
                </Grid>
              </>
            )}
          </form>
        </Grid>
      </Grid>
    </Container>
  );
}

InformEmail.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(InformEmail);
